import { useEffect } from 'react';

export interface UseAssembledChatScriptOptions {
  user_signed_in: boolean;
  ASSEMBLED_ENABLED: boolean;
}

/**
 * Hook to conditionally load the Assembled HQ chat script on the client-side.
 * Appends the script to document.head.
 */
export function useAssembledChatScript({
  user_signed_in,
  ASSEMBLED_ENABLED,
}: UseAssembledChatScriptOptions): void {
  const shouldLoad = !user_signed_in && ASSEMBLED_ENABLED;

  useEffect(() => {
    if (!shouldLoad) {
      return;
    }

    const attributes = {
      'data-company-id': 'df07c1d6-20b4-403d-8959-376d258ed86d',
      'data-profile-id': 'b9b2c35f-d083-4b94-8a4b-cdddd097f9c2',
    };
    const scriptId = 'assembled-base-script';

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://cal.assembledhq.com/static/js/public-chat.js';
    script.async = true;

    Object.entries(attributes).forEach(([key, value]) => {
      script.setAttribute(key, value as string);
    });

    document.head.appendChild(script);
  }, [shouldLoad]);
}
